import { SourceData } from '@/components/control/TableSelectBox'

export const USER_TYPE_ADMIN: SourceData = { value: 'ADMIN', name: '관리자' }
export const USER_TYPE_BORROWER: SourceData = { value: 'BORROWER', name: '대출자' }
export const USER_TYPE_ARRANGER: SourceData = { value: 'ARRANGER', name: '주선자' }
export const USER_TYPE_ADVISOR: SourceData = { value: 'ADVISOR', name: '자문사' }
export const USER_TYPE_INVESTOR: SourceData = { value: 'INVESTOR', name: '대주' }
export const USER_TYPE_GUEST: SourceData = { value: 'GUEST', name: '게스트' }
export const USER_TYPE_INVITER: SourceData = { value: 'INVITER', name: '초대자' }

export const USER_TYPE_LIST: SourceData[] = [
    USER_TYPE_ADMIN,
    USER_TYPE_BORROWER,
    USER_TYPE_ARRANGER,
    USER_TYPE_ADVISOR,
    USER_TYPE_INVESTOR
]


